import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { VantaBackground, vantaPresets } from 'src/components/Vanta';

import Header from './Header';

export default function Layout() {
  const theme = useTheme();
  const [customLayoutStyle, setCustomLayoutStyle] = useState<SxProps<Theme> | null>(null);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Header />

      <VantaBackground
        config={vantaPresets.halo}
        opacity={theme.palette.mode === 'dark' ? 0.2 : 1}
      />

      <Box
        id="layout"
        component="main"
        sx={{
          flex: 1,
          p: 2,
          position: 'relative',
          overflow: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: `${theme.palette.divider} transparent`,
          ...customLayoutStyle,
        }}
      >
        <Outlet context={{ setCustomLayoutStyle }} />
      </Box>
    </Box>
  );
}
